import type { RouletteNumber } from "../RouletteNumber/RouletteNumber.types";

export enum BadgeType {
  REGULAR = "REGULAR",
  JACKPOT = "JACKPOT",
  SEATS_AVAILABLE = "SEATS_AVAILABLE",
  ROULETTE_NUMBERS = "ROULETTE_NUMBERS",
  NEW = "NEW",
  NEW_REGULAR = "NEW_REGULAR",
  FEATURED = "FEATURED",
  TABLE_LIMITS = "TABLE_LIMITS",
}

export enum BadgeLayout {
  GAME_TILE_BADGE = "GAME_TILE_BADGE",
  GAME_INFO_BADGE = "GAME_INFO_BADGE",
}

export type BadgeProps = {
  /** Text label to display in the badge */
  label?: string;
  /** The visual style variant of the badge that determines its appearance and color scheme */
  badgeType?: BadgeType;
  /** List of roulette numbers to display when badge type is ROULETTE_NUMBERS. Each number has a color and value */
  rouletteNumbers?: RouletteNumber[];
  /** Layout variant that determines the size and positioning context */
  badgeLayout?: BadgeLayout;
};
